document.addEventListener("DOMContentLoaded", function () {
  function updateTurboDropdowns() {
    document.querySelectorAll(".product_form").forEach(function (form) {
      if (form.dataset.soldOutFilterReady === "true") return;

      var productJson = form.getAttribute("data-product");
      if (!productJson) return;

      var product;

      try {
        product = JSON.parse(productJson);
      } catch (error) {
        console.error("Unable to read product variant data:", error);
        return;
      }

      if (!product || !product.variants) return;

      var selectors = form.querySelectorAll(".single-option-selector");
      var masterSelector = form.querySelector('select[name="id"]');

      if (!selectors.length) return;

      function getSelectedValues() {
        return Array.from(selectors).map(function (selector) {
          return selector.value;
        });
      }

      function findAvailableVariant() {
        var selectedValues = getSelectedValues();

        return product.variants.find(function (variant) {
          if (!variant.available) return false;

          return variant.options.every(function (optionValue, index) {
            return optionValue === selectedValues[index];
          });
        });
      }

      function getAvailableValues(optionIndex) {
        var selectedValues = getSelectedValues();

        return product.variants
          .filter(function (variant) {
            if (!variant.available) return false;

            for (var i = 0; i < optionIndex; i++) {
              if (variant.options[i] !== selectedValues[i]) {
                return false;
              }
            }

            return true;
          })
          .map(function (variant) {
            return variant.options[optionIndex];
          })
          .filter(function (value, index, values) {
            return values.indexOf(value) === index;
          });
      }

      function rebuildSelector(optionIndex) {
        var selector = selectors[optionIndex];
        var currentValue = selector.value;
        var availableValues = getAvailableValues(optionIndex);

        selector.innerHTML = "";

        availableValues.forEach(function (value) {
          var option = document.createElement("option");
          option.value = value;
          option.textContent = value;
          selector.appendChild(option);
        });

        if (availableValues.includes(currentValue)) {
          selector.value = currentValue;
        } else if (availableValues.length > 0) {
          selector.value = availableValues[0];
        }
      }

      function synchronizeVariant() {
        var availableVariant = findAvailableVariant();

        if (!availableVariant) return;

        if (masterSelector) {
          masterSelector.value = availableVariant.id;

          masterSelector.dispatchEvent(
            new Event("change", {
              bubbles: true
            })
          );
        }

        selectors.forEach(function (selector) {
          selector.dispatchEvent(
            new Event("change", {
              bubbles: true
            })
          );
        });
      }

      selectors.forEach(function (selector, optionIndex) {
        rebuildSelector(optionIndex);

        selector.addEventListener("change", function () {
          for (
            var nextIndex = optionIndex + 1;
            nextIndex < selectors.length;
            nextIndex++
          ) {
            rebuildSelector(nextIndex);
          }

          var availableVariant = findAvailableVariant();

          if (availableVariant && masterSelector) {
            masterSelector.value = availableVariant.id;

            masterSelector.dispatchEvent(
              new Event("change", {
                bubbles: true
              })
            );
          }
        });
      });

      form.dataset.soldOutFilterReady = "true";

      setTimeout(synchronizeVariant, 300);
    });
  }

  setTimeout(updateTurboDropdowns, 500);
  setTimeout(updateTurboDropdowns, 1200);
  setTimeout(updateTurboDropdowns, 2000);
});